import React from 'react';
import { Heading, Flex } from '@spothero/ui';
import { DriverTagChip } from './DriverTagChip';
import { MOCK_DRIVER_TAGS } from './constants';
export const DriverTagsList = () => {
    const tags = MOCK_DRIVER_TAGS;
    const apiImplemented = false; // Hide until API is implemented
    const visibleTags = tags.filter(tag => tag.count >= 1);
    if (!apiImplemented || visibleTags.length === 0) {
        return null;
    }
    return (<>
            <Heading as="h6" fontWeight="semibold" fontSize="sm" marginBottom={2}>
                What Drivers Like
            </Heading>
            <Flex flexWrap="wrap" gap={2} marginBottom={3} data-testid="DriverTagsList">
                {visibleTags.map(tag => (<DriverTagChip key={tag.label} emoji={tag.emoji} label={tag.label} count={tag.count}/>))}
            </Flex>
        </>);
};
